import React from 'react'

const BookingPreview = ({ booking, className, onClick }) => {

  function handleClick(e) {
    if(onClick) {
      e.preventDefault()
      onClick && onClick(booking)
    }
  }

  return (
    <a href={`/events/${booking.attributes.eventId}`} className={`booking-preview w-100 ${className}`} onClick={handleClick}>
      <div>{ booking.attributes.formattedTimeRange }</div>
      <div>{ booking.attributes.title }</div>
    </a>
  )
}

export default BookingPreview
